import createIcon from '../../createIcon';

/**
 * @component @name Blender
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNjMgMTUuMTNMMTkuNSAzSDE1LjVWMkgxMS41VjNINi41QzUuNCAzIDQuNSAzLjkgNC41IDVWOUM0LjUgMTAuMSA1LjQgMTEgNi41IDExSDguNzNMOS4zNyAxNS4xM0M4LjI0IDE2LjA1IDcuNSAxNy40MyA3LjUgMTlWMjBDNy41IDIxLjEgOC40IDIyIDkuNSAyMkgxNy41QzE4LjYgMjIgMTkuNSAyMS4xIDE5LjUgMjBWMTlDMTkuNSAxNy40MyAxOC43NiAxNi4wNSAxNy42MyAxNS4xM1pNNi41IDlWNUg3LjgxTDguNDMgOUg2LjVaTTEzLjUgMTlDMTIuOTUgMTkgMTIuNSAxOC41NSAxMi41IDE4QzEyLjUgMTcuNDUgMTIuOTUgMTcgMTMuNSAxN0MxNC4wNSAxNyAxNC41IDE3LjQ1IDE0LjUgMThDMTQuNSAxOC41NSAxNC4wNSAxOSAxMy41IDE5Wk0xNS43OSAxNEgxMS4yMkw5LjgzIDVIMTcuMTdMMTUuNzkgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Blender = createIcon('Blender', [
  [
    'path',
    {
      d: 'M17.63 15.13L19.5 3H15.5V2H11.5V3H6.5C5.4 3 4.5 3.9 4.5 5V9C4.5 10.1 5.4 11 6.5 11H8.73L9.37 15.13C8.24 16.05 7.5 17.43 7.5 19V20C7.5 21.1 8.4 22 9.5 22H17.5C18.6 22 19.5 21.1 19.5 20V19C19.5 17.43 18.76 16.05 17.63 15.13ZM6.5 9V5H7.81L8.43 9H6.5ZM13.5 19C12.95 19 12.5 18.55 12.5 18C12.5 17.45 12.95 17 13.5 17C14.05 17 14.5 17.45 14.5 18C14.5 18.55 14.05 19 13.5 19ZM15.79 14H11.22L9.83 5H17.17L15.79 14Z',
      key: 'hcg5mv',
    },
  ],
]);

export default Blender;
